import React from 'react';
import {Navigate} from 'react-router';
import {Loader} from '@gravity-ui/uikit';
import {useSession} from '../../entities/auth/hooks/useSession';
import {roleHomePath} from '../../entities/auth/model';

export const RootRedirect = () => {
  const {role, isLoading} = useSession();

  if (isLoading) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <Loader size="l" />
      </div>
    );
  }

  return <Navigate to={roleHomePath(role)} replace />;
};
